import { render, staticRenderFns } from "./CommunityDocuments.vue?vue&type=template&id=2a85f934&"
import script from "./CommunityDocuments.vue?vue&type=script&lang=js&"
export * from "./CommunityDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports